import React, { useRef } from 'react';
var VeltCommentsSidebarV2FilterDropdownContentListItemIndicator = function (props) {
    var mode = props.mode, selected = props.selected, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-filter-dropdown-content-list-item-indicator-v2", { ref: ref, mode: mode, selected: [true, false].includes(selected) ? (selected ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentsSidebarV2FilterDropdownContentListItemIndicator;
